import type { VisibilityReportResponse } from '@brand24-original/llm-types';

/**
 * Snapshot trzyma angielski klucz tematu i (od pewnej wersji) polską nazwę. Dla PL podmieniamy etykiety
 * w trzech slajdach tematycznych w jednym miejscu — komponenty slajdów nie znają języka.
 */
export const localizeReportTopics = (
  report: VisibilityReportResponse,
  language: string
): VisibilityReportResponse => {
  if (!language.startsWith('pl')) {
    return report;
  }
  return {
    ...report,
    topicShares: report.topicShares.map((entry) => ({ ...entry, topic: entry.topicPl ?? entry.topic })),
    brandPresence: {
      ...report.brandPresence,
      topics: report.brandPresence.topics.map(
        (topic, index) => report.brandPresence.topicsPl[index] ?? topic
      ),
    },
    contextGaps: report.contextGaps.map((gap) => ({ ...gap, topic: gap.topicPl ?? gap.topic })),
  };
};
